/**
 * kult-signature.js — Röst-Timeline (Schieberegler 0–20 Minuten) und Fakten-Zähler.
 * Beide Komponenten funktionieren ohne JS als statische Inhalte; JS ergänzt Bewegung.
 */
(function () {
  'use strict';
  // Init-Guard (30.09.2026): Die Datei wird auf manchen Seiten von mehreren Sections eingebunden.
  if (window.__kultSignatureInit) return;
  window.__kultSignatureInit = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Röst-Timeline ---------- */
  var STOPS = [
    { t: 0, c: [127, 163, 107] },   // grün (Rohkaffee)
    { t: 5, c: [201, 168, 106] },   // gelblich (Trocknung)
    { t: 12, c: [163, 103, 46] },   // hellbraun (Maillard/First Crack)
    { t: 20, c: [74, 42, 21] }      // röstbraun (Entwicklung)
  ];
  function beanColor(t) {
    for (var i = 1; i < STOPS.length; i++) {
      if (t <= STOPS[i].t) {
        var a = STOPS[i - 1], b = STOPS[i], f = (t - a.t) / (b.t - a.t);
        var c = a.c.map(function (v, k) { return Math.round(v + (b.c[k] - v) * f); });
        return 'rgb(' + c.join(',') + ')';
      }
    }
    return 'rgb(' + STOPS[STOPS.length - 1].c.join(',') + ')';
  }
  function fmt(t) {
    var m = Math.floor(t), s = Math.round((t - m) * 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  document.querySelectorAll('[data-roast-timeline]').forEach(function (root) {
    var range = root.querySelector('[data-rt-range]');
    var bean = root.querySelector('[data-rt-bean]');
    var minute = root.querySelector('[data-rt-minute]');
    var phaseEl = root.querySelector('[data-rt-phase]');
    var text = root.querySelector('[data-rt-output]');
    var phases = Array.prototype.slice.call(root.querySelectorAll('[data-rt-from]'));
    if (!range) return;
    function update() {
      var t = parseFloat(range.value);
      if (bean) bean.style.fill = beanColor(t);
      if (minute) minute.textContent = fmt(t) + ' Min.';
      var active = null;
      phases.forEach(function (li) {
        var from = parseFloat(li.dataset.rtFrom), to = parseFloat(li.dataset.rtTo);
        var on = t >= from && (t < to || (to >= 20 && t >= 20));
        li.classList.toggle('is-active', on);
        if (on) active = li;
      });
      if (active) {
        if (phaseEl) phaseEl.textContent = active.dataset.rtName;
        if (text) text.textContent = active.dataset.rtText;
        range.setAttribute('aria-valuetext', fmt(t) + ' Minuten, ' + active.dataset.rtName);
      }
      // Additiv (18.09.2026): Startseite koppelt sich per Event an die Timeline
      // (kult-home.js hört auf 'kult:rt:change', kein MutationObserver). Bubbles bis document.
      root.dispatchEvent(new CustomEvent('kult:rt:change', {
        bubbles: true,
        detail: { minute: t, phase: active ? active.dataset.rtName : '' }
      }));
    }
    range.addEventListener('input', update);
    update();
    // Auto-Play beim ersten Sichtbarwerden: einmal von 0 bis 20 laufen, danach frei bedienbar
    if (!reduced && 'IntersectionObserver' in window) {
      var played = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || played) return;
          played = true; io.disconnect();
          if (root.dataset.rtUser) return; // Diagramm (kult-roast-chart.js) oder Nutzer:in führt die Timeline bereits
          var start = null, dur = 4000;
          function step(ts) {
            if (!start) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            range.value = (p * 20).toFixed(1);
            update();
            if (p < 1 && !root.dataset.rtUser) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.5 });
      io.observe(root);
      range.addEventListener('pointerdown', function () { root.dataset.rtUser = '1'; });
      range.addEventListener('keydown', function () { root.dataset.rtUser = '1'; });
    }
  });

  /* ---------- Fakten-Zähler ---------- */
  document.querySelectorAll('[data-count-to]').forEach(function (el) {
    var target = parseFloat(String(el.dataset.countTo).replace(',', '.'));
    var decimals = parseInt(el.dataset.countDecimals || '0', 10);
    var suffix = el.dataset.countSuffix || '';
    var prefix = el.dataset.countPrefix || '';
    function render(v) { el.textContent = prefix + v.toFixed(decimals).replace('.', ',') + suffix; }
    /* Jahreszahlen („seit 2010“) nicht hochzählen: Zwischenstände wie „seit 1667“ wirken falsch (UI-Audit 10.10.2026) */
    var isYear = decimals === 0 && target >= 1900 && target <= 2100;
    if (reduced || isNaN(target) || isYear || !('IntersectionObserver' in window)) { render(isNaN(target) ? 0 : target); return; }
    render(0);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        var start = null, dur = 900;
        setTimeout(function () { render(target); }, dur + 600); // Sicherheitsnetz, falls rAF gedrosselt wird
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          render(target * eased);
          if (p < 1) requestAnimationFrame(step); else render(target);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  });
})();
